import {apiRequest} from "./client";
export const fetchWebsiteSettings=async()=>(await apiRequest("/website-settings")).data;
export const saveWebsiteSettings=async(settings)=>(await apiRequest("/website-settings",{method:"PUT",body:JSON.stringify(settings)})).data;
